import { Files } from '../../lib/constants/files'
import { TransportMeanInput } from '../../lib/types/models/transport-means/transport-means-input'
import { UpdateInput } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function updateTransportMean(data: UpdateInput<TransportMeanInput>) {
  const { id, picto, ...rest } = data
  const s3Picto = await uploadFile(Files.TRANSPORT_MEAN_PICTO, picto)

  return restApiClient.url(constructApiUrl(API.transportMeans.update.url, { id })).patch({
    ...rest,
    picto: s3Picto
  })
}
